import * as React from "react";

function SvgCrossIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 190 190" {...props}><path d="M167.2 33.4l-10.6-10.6-61.7 61.7-61.7-61.7-10.6 10.6 61.7 61.7-61.7 61.7 10.6 10.6 61.7-61.7 61.7 61.7 10.6-10.6-61.7-61.7z" /></svg>;
}

export default SvgCrossIcon;